import { AnyAction, combineReducers } from '@reduxjs/toolkit'

import { orderReducer as order } from '@/entities/order/model/order-slice'

import { sharedReducers } from './rootReducer'

export const orderFlowCombinedReducer = combineReducers({
	...sharedReducers,
	order
})

export type OrderFlowRootState = ReturnType<typeof orderFlowCombinedReducer>

export const orderFlowRootReducer = (state: OrderFlowRootState, action: AnyAction) =>
	orderFlowCombinedReducer(state, action)
